import { useMergedRef } from '@/hook';

import { VFlex } from '../VFlex';
import { SLIDER_THUMB_SIZE } from './constant';
import { useVSliderContext, useVSliderThumb } from './hook';
import type { VSliderThumbProps } from './type';

export const VSliderThumb = ({
  ref,
  thumbValue,
}: React.ComponentPropsWithRef<'div'> & VSliderThumbProps) => {
  const {
    disabled,
    eventEmitter,
    normalizedValue,
    normalizedMarkerItemMap,
    max,
    min,
    readOnly,
    step,
    style,
    type,
    value,
    setValue,
  } = useVSliderContext();
  const { $thumb, thumbThresholdTx } = useVSliderThumb<any>({
    disabled,
    normalizedMarkerItemMap,
    normalizedValue,
    max,
    min,
    readOnly,
    step,
    thumbValue,
    type,
    value,
    setValue,

    onThumbMove(payload, trigger) {
      eventEmitter.emit('thumbMove', payload, { trigger });
    },
  });
  const mergedRef = useMergedRef(ref, $thumb);

  return (
    <VFlex
      ref={mergedRef}
      aria-disabled={disabled}
      aria-label="v-slider-thumb"
      aria-readonly={readOnly}
      aria-valuenow={thumbValue}
      aria-valuemax={thumbThresholdTx[1]}
      aria-valuemin={thumbThresholdTx[0]}
      className={style.thumb}
      style={
        {
          '--tx': 0,
          '--thumb-size': `${SLIDER_THUMB_SIZE}px`,
        } as React.CSSProperties
      }
      justify="center"
      items="center"
    />
  );
};

VSliderThumb.displayName = 'VSliderThumb';
